export default "__VITE_ASSET__a1b57943__"